import { SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Input } from "antd";
import { forwardRef, useCallback, useMemo, useRef, useState } from "react";
import styled from "styled-components";



const SearchBarWrapper = styled.div`
  position: absolute;
  top: 1em;
  left: calc(50% - 25em);
  max-width: 50em;
  width: 100%;
  z-index: 1000;
  margin-left: auto;
  margin-right: auto;

  input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button {
    height: 36px;
  }
`

const highlightSearchText = (fullText, searchText) => {
      const index = fullText.toLowerCase().indexOf(searchText.toLowerCase());
      const prefix = index >= 0 ? fullText.substring(0, index) : fullText;
      const main = index >= 0 ? fullText.substring(index, index + searchText.length) : '';
      const suffix = index >= 0 ? fullText.substring(index + searchText.length) : '';
      return <>{prefix}<b>{main}</b>{suffix}</>
}

const SearchInput = forwardRef(({ value, employees, customers, ...rest }: any, ref: any) => {
  const innerValue = useMemo(() => {
    if(value?.startsWith("#employee:")) {
      const id = parseInt(value.substring("#employee:".length));
      const employee = employees?.find(e => e.id === id);
      return `${employee?.firstName} ${employee?.lastName}`
    } else if(value?.startsWith("#customer:")) {
      const id = parseInt(value.substring("#customer:".length));
      const customer = customers?.find(e => e.id === id);
      return `${customer?.firstName} ${customer?.lastName}`
    } else if(value?.startsWith("#address:")) {
      return value.substring("#address:".length)
    }
    return value;
   }, [employees, customers, value])
  return <Input ref={ref} value={innerValue} {...rest} size="large" placeholder="Suche" />
});

const SearchBar = ({ onSearch, employees, customers, allowAddressSearch }: any) => {
  const [tmpSearchText, setTmpSearchText] = useState<string>("")
  const searchTimeoutRef = useRef<any>();
  
  const optionsEmployees = (employees || []).filter(e => e.lastName?.toLowerCase().includes(tmpSearchText.toLowerCase()) || e.firstName?.toLowerCase().includes(tmpSearchText.toLowerCase())).sort((a, b) => a.lastName?.localeCompare(b?.lastName)).map(e => ({ label: <>{highlightSearchText(`${e.firstName || ''} ${e.lastName || ''}`, tmpSearchText)}</>, value: `#employee:${e.id}`}));
  const optionsCustomers = (customers || []).filter(e => e.lastName?.toLowerCase().includes(tmpSearchText.toLowerCase()) || e.firstName?.toLowerCase().includes(tmpSearchText.toLowerCase())).sort((a, b) => a.lastName?.localeCompare(b?.lastName)).map(e => ({ label: <>{highlightSearchText(`${e.firstName || ''} ${e.lastName || ''}`, tmpSearchText)}</>, value: `#customer:${e.id}`}));
  const strippedAddress = useMemo(() => {
    if(tmpSearchText.startsWith("#employee:") || tmpSearchText.startsWith("#customer:")) {
      return "";
    } else if(tmpSearchText.startsWith("#address:")) {
      return tmpSearchText.substring("#address:".length);
    }
    return tmpSearchText
  }, [tmpSearchText])
  const optionsAddress = allowAddressSearch ? [{ label: <strong>{strippedAddress}</strong>, value: `#address:${strippedAddress}` }] : [];
  const options = [
    ...(optionsEmployees.length > 0 ? [{ label: "Mitarbeitende", options: optionsEmployees }] : []), 
    ...(optionsCustomers.length > 0 ? [{ label: "Kunden", options: optionsCustomers}] : []), 
    ...(strippedAddress.length > 0 ? [{ label: "Adresse", options: optionsAddress }] : [])]

  const onInnerSearch = useCallback((searchText) => {
    clearTimeout(searchTimeoutRef.current);
    let searchObject;
    if(searchText.startsWith("#employee:")) {
      const id = parseInt(searchText.substring("#employee:".length));
      const employee = employees?.find(e => e.id === id);
      searchObject = {
        ...employee,
        type: "employee"
      }
    } else if(searchText.startsWith("#customer:")) {
      const id = parseInt(searchText.substring("#customer:".length));
      const employee = customers?.find(e => e.id === id);
      searchObject = {
        ...employee,
        type: "customer"
      }
    } else {
      let address = searchText;
      if(searchText.startsWith("#address:")) {
        address = searchText.substring("#address:".length)
      }
      searchObject = {
        address,
        type: "address"
      }
    }
    onSearch(searchObject);
  }, [customers, employees, onSearch, searchTimeoutRef])

  const onInputKeyDown = useCallback(evt => {
    if(evt.code === 'Enter') {
      searchTimeoutRef.current = setTimeout(() => onInnerSearch(tmpSearchText), 100);
    }
  }, [tmpSearchText, onInnerSearch])

  return (<SearchBarWrapper>
    <AutoComplete style={{ width: 'calc(100% - 2em - 3px)' }} options={options} value={tmpSearchText} onChange={setTmpSearchText}
        onSelect={e => { console.log("Selected", e); onInnerSearch(e) } } onInputKeyDown={onInputKeyDown} >
      <SearchInput employees={employees} customers={customers} />
    </AutoComplete><Button style={{ width: '2em', borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} onClick={() => onInnerSearch(tmpSearchText)} icon={<SearchOutlined />} />
  </SearchBarWrapper>)
}

export default SearchBar;